import {appConfig} from './app/app.config';
import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {registerLocaleData} from '@angular/common';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEn, 'en');
registerLocaleData(localeEs, 'es');

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));


/**
 * TODO: validar diseño del header según nivel del cliente
 * TODO: validar tema según nivel del cliente
 * TODO: validar user profile overlay según nivel del cliente
 * TODO: crear objeto de validación por módulos y características
 * TODO: crear servicio par manejar el estado de la sesión soporte/ sesión de permisos elevados
 * TODO: crear el interceptor para validar la sesión
 * TODO: rediseñar las cards de los paneles
 *
 */
